import * as DateUtils from './DateUtils';

export function base64StringFileToBlob(content: string, fileType: 'pdf' | 'excel') {
	switch (fileType) {
		case 'pdf':
			return base64StringToBlob(content as any, { type: 'application/pdf' });
		case 'excel':
			return base64StringToBlob(content as any, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
		default:
			throw Error(`Cannot create blob for unknown fileType ${fileType}`);
	}

}

export function base64StringToBlob(base64: string, options?: BlobPropertyBag): Blob {
	const byteChars = atob(base64);
	const bytes = new Array<number>(byteChars.length);

	for (let i = 0; i < byteChars.length; i++) {
		bytes[i] = byteChars.charCodeAt(i);
	}

	const bytesArray = new Uint8Array(bytes);

	// Aunque el segundo parámetro podría ser undefined según TypeScript, según Safari en iOS no, y se enfada mucho y explota
	return new Blob([bytesArray], options || {});
}

export function htmlImageToBase64(image: HTMLImageElement, mimeType: string, width: number, height: number) {

	const canvas = document.createElement('canvas');
	const ctx = canvas.getContext('2d');

	if (ctx) {
		canvas.width = width;
		canvas.height = height;

		ctx.drawImage(image, 0, 0, width, height);
		return canvas.toDataURL(mimeType).split(',')[1];
	}

	throw new Error('No existe un contexto 2d para devolver la imagen en base64');
}

export function blobToHTMLImage(blob: Blob): Promise<{ img: HTMLImageElement, mimeType: string }> {

	return new Promise((resolve, _reject) => {

		const url = URL.createObjectURL(blob);
		const img = new Image();

		img.src = url;
		img.onload = () => resolve({ img, mimeType: blob.type });
	});
}

export function imageSrcToHTMLImage(src: string): Promise<HTMLImageElement> {

	return new Promise((resolve, reject) => {

		const img = new Image();

		img.src = src;
		img.onload = () => resolve(img);
		img.onerror = () => reject(new Error('No se pudo cargar la imagen'));
	});
}

export function fileToDataUrl(file: Blob | File): Promise<string> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();

		reader.onload = () => {
			if (typeof reader.result === 'string')
				resolve(reader.result);
			else
				reject(new Error('No se pudo leer el fichero.'));
		};

		reader.onerror = () => reject(reader.error || new Error('No se pudo leer el fichero.'));
		reader.readAsDataURL(file);
	});
}

export function blobToBase64String(blob: Blob): Promise<string> {
	const reader = new FileReader();

	const base64promise = new Promise<string>((resolve, _reject) => {
		reader.onload = (ev: any) => {
			resolve(ev.target.result.split(',')[1]);
		};
	});

	reader.readAsDataURL(blob);
	return base64promise;
}

export function objectToBase64<T>(object: T): string {

	// Serializo la hora como local para que luego al hacer el base64ToObject se mantenga tal cual
	const DATE_REQUEST_REGEXP = new RegExp(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/);

	const valueReplacer = (_key: any, value: any) => {
		if (typeof value === 'string' && value.match(DATE_REQUEST_REGEXP)) {
			// Convierto otra vez a hora local y serializo
			const date = new Date(value);
			return DateUtils.formatDate(date, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS');
		}
		return value;
	};

	return btoa(JSON.stringify(object, valueReplacer));
}

export function base64ToObject<T>(base64: string): T {

	// eslint-disable-next-line no-useless-escape
	const DATE_RESPONSE_REGEXP = new RegExp(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?([\+|-]\d{2}:\d{2})?$/);

	const reviver = (_key: string, value: string) =>
		typeof value === 'string' && value.match(DATE_RESPONSE_REGEXP) ? DateUtils.parseDate(value) : value;

	return JSON.parse(atob(base64), reviver);
}
